module.exports = __webpack_public_path__ + "static/media/dawn-lose.d0216a2d.png";